<template>
  <div class="table-wrapper">
    <el-table
      :data="data"
      stripe
      style="width: 100%"
      size="medium"
      header-row-class-name="common-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      :border="false"
    >
      <el-table-column prop="createTime" label="时间" width="180"></el-table-column>
      <el-table-column prop="flowId" label="交易流水号"></el-table-column>
      <el-table-column prop="orderSn" label="三方订单号">
        <template slot-scope="{ row }">
          {{ row.orderSn || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="operateType" label="类型">
        <template slot-scope="{ row }">
          {{ operateTypeMap[row.operateType] || '' }}
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="金额(元)">
        <template slot-scope="{ row }">
          {{ row.amount | fen2Yuan }}
        </template>
      </el-table-column>
      <el-table-column prop="balanceSnapshot" label="余额(元)">
        <template slot-scope="{ row }">
          {{ row.balanceSnapshot | fen2Yuan }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="{ row }">
          <span class="btn" @click="goViewDetail(row)">详情</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrapper">
      <el-pagination
        class="is-print-hide common-el-pagination"
        layout="prev, pager, next, total, jumper, sizes"
        :total="total"
        :current-page="pageNo"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        @current-change="val => $emit('handle-pageNo', val)"
        @size-change="val => $emit('handle-pageSize', val)"
      />
      <div class="sureJump global_common_button_goast">确定</div>
    </div>
  </div>
</template>

<script>
import Fetch from '@/api';

export default {
  name: 'drugsManagement',
  props: {
    data: {
      type: Array
    },
    total: {
      type: Number
    },
    pageNo: {
      type: Number
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array
    }
  },
  data() {
    return {
      operateTypeMap: {
        1: '调账',
        2: '充值',
        3: '服务费扣减',
        4: '服务费返还'
      }
    };
  },
  methods: {
    goViewDetail(row) {
      this.$emit('detail', row);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  color: #1e8dff;
  font-size: 12px;
  cursor: pointer;

  & + .btn {
    margin-left: 5px;
  }
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;

  /deep/.el-pagination {
    margin-top: 0;
  }

  .sureJump {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    width: 80px;
    height: 32px;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>
